module.exports = __webpack_public_path__ + "static/handyman-4812eefc081407e4ecd02b682b3152e0.jpeg";